import React from 'react';
import { Box } from '@mui/material';
import SubmarketTooltip from './SubmarketTooltip';
import { COLOR_PRIMARY_2 } from 'src/utils/colors';
import OpenInNewRoundedIcon from '@mui/icons-material/OpenInNewRounded';

const SubmarketMapMarket = ({
  text,
  lat,
  lng,
  submarketData,
  handleOnSampleClick,
  isSubmarketAccessAllowed,
  setDashboardLayoutView,
  handleHideSubmarket,
  isMobileScreen,
  sx,
}: {
  text: string; 
  lat: number;
  lng: number;
  submarketData: any;
  handleOnSampleClick: (plan: string) => void;
  isSubmarketAccessAllowed: boolean;
  setDashboardLayoutView: (view: string) => void;
  handleHideSubmarket: (submarketId: string) => void;
  isMobileScreen: boolean;
  sx: any;
}) => {
  return (
  <SubmarketTooltip
    content={submarketData.submarketDescription}
    submarketData={submarketData}
    title={text}
    handleOnSampleClick={handleOnSampleClick}
    isSubmarketAccessAllowed={isSubmarketAccessAllowed}
    setDashboardLayoutView={setDashboardLayoutView}
    showCta={true}
    ctaSource='map'
    handleHideSubmarket={handleHideSubmarket}
  >
    <Box
      onClick={() => {
        if (isSubmarketAccessAllowed) {
          isMobileScreen && window.open(submarketData.submarket_url, '_blank');
        } else {
          handleOnSampleClick('expert');
        }
      }}
      sx={{
        color: COLOR_PRIMARY_2,
        fontWeight: 'bold',
        position: 'absolute',
        width: '200px',
        padding: '10px',
        // height: '30px',
        backgroundColor: 'white',
        borderRadius: '200px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transform: 'translate(-50%, -50%)',
        boxShadow: '0 2px 4px #0002',
        zIndex: 9999999,
        cursor: 'pointer',
        transition: 'all 0.3s ease',
        '&:hover': {
          backgroundColor: COLOR_PRIMARY_2,
          color: 'white',
        },
        ...sx,
      }}
    >
      {submarketData.submarket_name}
      {isMobileScreen && <OpenInNewRoundedIcon sx={{ fontSize: '16px', ml: 1, transform: 'translateY(0px)' }} />}
    </Box>
  </SubmarketTooltip>
)};

export default React.memo(SubmarketMapMarket);
